import angular from 'angular';
import _ from 'lodash';

export default angular.module('documents-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      documents: {
        DOCUMENT_CATEGORY_IS_IN_USE: () => ({ title: gettextCatalog.getString('Category has documents. You cannot delete a category that has documents.') }),
        DOCUMENT_ALREADY_EXISTS: () => ({ title: gettextCatalog.getString('Document already exists.') }),
        CANNOT_BE_EMPTY: () => ({ title: gettextCatalog.getString('Document cannot be empty.') }),
        CATEGORY_EXIST: () => ({ title: gettextCatalog.getString('Category with this name already exists.') }),
        DOCUMENT_TYPE_NOT_ALLOWED: () => ({ title: gettextCatalog.getString('Not allowed document type.') }),
        INVALID_SIZE: () => ({ title: gettextCatalog.getString('Size must be between 0 and 255 characters.') }),
        INVALID_DOCUMENT_NAME_SIZE: () => ({ title: gettextCatalog.getString('Document name must be between 0 and 255 characters.') }),
        INVALID_THUMBNAIL_FORMAT: () => ({ title: gettextCatalog.getString('File must be an image in JPEG / JPG or PNG format.') }),
        INVALID_THUMBNAIL_SIZE: () => ({ title: gettextCatalog.getString('Maximum thumbnail size is 256KB.') }),
        INVALID_THUMBNAIL: () => ({ title: gettextCatalog.getString('Maximum thumbnail size is 256KB.') }),
        INVALID_THUMBNAIL_DIMENSIONS: () => ({ title: gettextCatalog.getString('Thumbnail image must be between 300x300px and 500x500px.') }),
        INVALID_FILE_SIZE: () => ({ title: gettextCatalog.getString('File size must be below 50 MB".') }),
        TAG_NOT_FOUND: () => ({ title: gettextCatalog.getString('Tag not found.') }),
        TAG_NOT_UNIQUE: () => ({ title: gettextCatalog.getString('Tags must be unique.') }),
        DOCUMENT_NOT_FOUND: () => ({ title: gettextCatalog.getString('Document not found.') }),
        CATEGORY_NOT_FOUND: () => ({ title: gettextCatalog.getString('Category not found.') }),
        INVALID_CONTENT_SIZE: () => ({ title: gettextCatalog.getString('The maximum file size must be up to 50 MB.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/documents/config/errorcodes.conf.js